$(document).ready(function(e) {
	
	$(".btn_scorall").click(function() {
		$('html, body').animate({
			scrollTop: $("#getOrder").offset().top - 50
		}, 2000);
	});
	
	var video = $('#myVdo video')[0];
	
	$('.ugc1').click(function(e) {
		$('.ugc-modal').addClass('active');
		$('.video-container').show(); 
		
		var videoFile = $(this).attr('data-vdo');
		$('.opw-video').attr('src', (videoFile + '?autoPlay=true'));
		
    });
	
	$('.ugc-close').click(function(e) {
       $('.ugc-modal').removeClass('active');
	   $('.video-container').hide();
	   $('.opw-video').attr('src','');
    });
			
	//accordion JS 
	$(".acdn-heading").click(function() {
			
		var questionDiv = $(this);
		var answerDiv   = $(this).next('.acdn-content');
		var idx = $('.acdn-content').index(answerDiv);
		
		$('.acdn-content').each(function(index, ansDiv) {
			if(index != idx && $(ansDiv).is(':visible')) {
				$(ansDiv).slideUp(500, function() {
					$(ansDiv).prev('.acdn-heading').removeClass('accordion-open');
				});
			}
		});
					
		if (answerDiv.is(':visible')) {
			answerDiv.stop().slideUp(500, function() {
				questionDiv.removeClass('accordion-open');
			});
		} else {
		  questionDiv.addClass('accordion-open');
		  answerDiv.stop().slideDown(500);
		}
		
	});
	
});
	
$(document).scroll(function() {
		
	if ($(this).scrollTop() > 40){
		$('.top-fix-bar').addClass('fixed-nav');
	}else{
		$('.top-fix-bar').removeClass('fixed-nav');
	}
	
});